export const isLegalDocumentPath = (path) =>
  /^\/about(?:\/(?:terms-of-use|privacy-policy))?\/?$/.test(path);
export const documentTypes = { about: 'about', terms: 'TERMS_OF_USE', privacy: 'PRIVACY_POLICY' };
